/** Only same-origin, path-absolute redirect targets ("/pair?code=…"), never "//evil.example". */
export const safeRedirect = (value: unknown): string | undefined => {
  if (typeof value !== "string") return undefined
  if (!value.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) return undefined
  return value
}
